
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchMyBillingDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cmsId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CmsBillingDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cmsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmsId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_period"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPeriodTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tax_rate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextBillingDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interval"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriod"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingPeriodFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingLineItemFields"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cost_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batch_size"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bill_minimum_batch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bill_partial_batches"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metered_actual_cost"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"effectivePrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasCustomPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extensionEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extensionSupported"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1151}};
    doc.loc.source = {"body":"#import \"../fragments/BillingPeriod.gql\"\n#import \"../fragments/BillingLineItem.gql\"\n\nquery FetchMyBillingDetail($cmsId: Int!) {\n    CmsBillingDetail(cmsId: $cmsId) {\n        cms {\n            id\n            name\n            billing_period\n        }\n        summary {\n            currentPeriodTotal\n            tax_rate\n            nextBillingDate\n            interval\n        }\n        currentPeriod {\n            ...BillingPeriodFields\n            lineItems {\n                ...BillingLineItemFields\n            }\n        }\n        pricing {\n            feature {\n                id\n                key\n                type\n                label\n            }\n            cost {\n                id\n                cost_type\n                label\n                price\n                billing_type\n                unit_label\n                batch_size\n                bill_minimum_batch\n                bill_partial_batches\n                metered_actual_cost\n            }\n            effectivePrice\n            customPrice\n            hasCustomPrice\n            enabled\n            extensionEnabled\n            extensionSupported\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/BillingPeriod.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/BillingLineItem.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FetchMyBillingDetail"] = oneQuery(doc, "FetchMyBillingDetail");
        
